/// <reference path="../app.js"/>

const FX_PARALLAX_SCALE = 50;
const FX_APPEAR_BOTTOM = 100;

class ParallaxElement {
	updateDocumentOffset() {
		this.documentOffset = FX.resolveDocumentOffset(this.element) + this.element.clientHeight / 2;
	}

	updateStyles() {
		if (this.scale.y > 0)
			this.element.style.setProperty("--parallax-y", ((this.documentOffset - (scrollY + (innerHeight / 2))) / (innerHeight / 2)) * this.scale.y * FX_PARALLAX_SCALE + "px");
		
		// if (this.scale.x > 0)
		// 	this.element.style.setProperty("--parallax-x", ((((1 / innerHeight) * (this.rect.top + (this.rect.height / 2))) * 2 - 1) * this.scale.x * FX_PARALLAX_SCALE) + "px");
	}

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.element = element;

		const parseParallaxValue = (attr, fallback = 1) => {
			let value = fallback;

			switch(attr.trim().toLowerCase()) {
				case "near": return 3;
				case "medium": return 2;
				case "far": return 1;
				default:
				value = parseFloat(attr);
				break;
			}

			if (isNaN(value)) value = fallback;

			return value;
		}

		let value = element.getAttribute("fx-parallax").split(",");
		let y = parseParallaxValue(value[0] || "_");
		let x = parseParallaxValue(value[1] || "_", 0);

		this.scale = { x, y };

		this.updateDocumentOffset();
	}
}

class AppearElement {
	updateDocumentOffset() {
		this.documentOffset = FX.resolveDocumentOffset(this.element);
	}

	updateVisibility() {
		if (!this.active && this.documentOffset < scrollY + (innerHeight -FX_APPEAR_BOTTOM)) {
			this.active = true;
			
			if (this.documentOffset - scrollY < 0) {
				this.element.setAttribute("fx-appear", "show");
			}
			else {
				setTimeout(() => {
					this.element.setAttribute("fx-appear", "show");
					FX.appearDelay = Math.max(FX.appearDelay - 1, 0);
				}, FX.appearDelay * 200);

				FX.appearDelay = Math.min(FX.appearDelay + 1, 6);
			}
		}
	}

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.element = element;
		this.active = false;

		this.updateDocumentOffset();
	}
}

class FX {
	static resolveDocumentOffset(element) {
		let iteratedElement = element;
		let offset = iteratedElement.offsetTop;

		while (iteratedElement.offsetParent) {
			iteratedElement = iteratedElement.offsetParent;
			offset += iteratedElement.offsetTop;
		}

		return offset;
	};

	static registerParallax(element) {
		if (element.getAttribute("fx-parallax") == null) return;

		FX.parallaxElements.push(new ParallaxElement(element));
	}

	static registerAppear(element) {
		if (element.getAttribute("fx-appear") == null) return;

		FX.appearElements.push(new AppearElement(element));
	}

	static onScroll() {
		let selectedBackgroundSize = -1;
		let backgroundColor = document.body.style.backgroundColor;

		this.backgroundElements.forEach(element => {
			let parent = element.parentElement;
			const boundingRect = parent.getBoundingClientRect();
			
			if (boundingRect.top > -boundingRect.height && boundingRect.top < innerHeight) {
				const size = (1 / innerHeight) * (boundingRect.height - Math.abs(boundingRect.top));
				if (selectedBackgroundSize < size) {
					selectedBackgroundSize = size;
					backgroundColor = element.style.backgroundColor;
				}
			}
		});

		if (typeof this.backgroundVisible != "undefined") this.backgroundVisible.css("background-color", backgroundColor);

		if (window.innerWidth > 600) {
			for (let element of this.parallaxElements) {
				element.updateStyles();
			}
		}

		for (let element of this.appearElements) {
			element.updateVisibility();
		}
	}

	static init() {
		/** @type {HTMLElement[]} */
		this.backgroundElements = [];
		/** @type {HTMLElement[]} */
		this.parallaxElements = [];
		/** @type {HTMLElement[]} */
		this.appearElements = [];
		
		this.appearRemove = [];

		this.appearDelay = 0;

		if ($("[fx-background]").length > 0) this.backgroundVisible = $(`<fx-background class="visible" style="background-color: transparent"></fx-background>`).prependTo(document.body);

		$("[fx-background]").each(function() {
			let element = $(this);
			FX.backgroundElements.push($(`<fx-background style="background-color: ${element.attr("fx-background")}"></fx-background>`).prependTo(element)[0]);
		});

		$("[fx-parallax]").each(function() {
			FX.registerParallax(this);
		});

		$("[fx-appear]").each(function() {
			if (this.getAttribute("fx-appear") == "children") {
				this.removeAttribute("fx-appear");
				
				$(this).children().each(function() {
					this.setAttribute("fx-appear", "");
					FX.registerAppear(this);
				})
			}
			else FX.registerAppear(this);
		});

		document.addEventListener("scroll", () => this.onScroll(), { passive: true });
		window.addEventListener("resize", () => {
			for (let element of this.parallaxElements) {
				element.updateDocumentOffset();
			}

			for (let element of this.appearElements) {
				element.updateDocumentOffset();
			}
		});

		window.addEventListener("fx-reflow", () => {
			for (let element of this.parallaxElements) {
				element.updateDocumentOffset();
			}

			for (let element of this.appearElements) {
				element.updateDocumentOffset();
			}
		});

		this.onScroll();
	}
}
